import { Component, OnInit, OnDestroy } from '@angular/core';

@Component({
    selector: 'wego-content-wrapper',
    template : '<router-outlet></router-outlet>',
})

export class ContentWrapperComponent implements OnInit, OnDestroy {
    constructor() { }
    ngOnInit() {  }
    ngOnDestroy() {  }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/admin-template/components/content-wrapper.component.ts